import {Poi} from '../models';

export class PoisState {
  all: Poi[];
}
